<template>
    <div id="CreateIkasChannel" class="ikas-channel-form">
        <div class="header">
            <IkasIcon class="ikas-icon" />
        </div>
        <p class="description">
            İkas panel URL'nizdeki
            <span class="url">https://<span class="highlight">example</span>.myikas.com/</span>
            kısmını domain alanına yazmalısınız.
        </p>
        <div class="form">
            <label class="label">Domain</label>
            <input
                type="text"
                placeholder="Domain adresinizi giriniz"
                class="input"
                autocomplete="off"
                v-model="form.domain"
            />

            <label class="label">Client ID</label>
            <input
                type="text"
                placeholder="Client ID"
                class="input"
                autocomplete="off"
                v-model="form.client_id"
            />

            <label class="label">Client Secret</label>
            <input
                type="text"
                placeholder="Client Secret"
                class="input"
                autocomplete="off"
                v-model="form.client_secret"
            />
        </div>

        <div class="actions">
            <button type="button" class="btn cancel" @click="handleCancel">Vazgeç</button>
            <button
                type="button"
                class="btn primary"
                :disabled="loading"
                @click="handleSubmit"
            >
                <span v-if="loading">Bağlanıyor...</span>
                <span v-else>Bağlan</span>
            </button>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import IkasIcon from "../../Chatbot/pages/integrations/svg/IkasIcon.vue";

export default {
    name: "CreateIkasChannel",
    components: { IkasIcon },
    data() {
        return {
            form: {
                domain: "",
                client_id: "",
                client_secret: "",
            },
            loading: false,
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site?._id,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        completeCreateChannel(payload) {
            const data = {
                payload: payload,
                type: "ikas",
                name: "IKAS",
            };
            this.createChannel(data)
                .then(() => {
                    this.$message.success("Channel created successfully");
                    this.$emit("ok");
                })
                .catch(() => {
                    this.$message.error("Failed to create channel");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSubmit() {
            this.submitClicked = true;
            this.loading = true;
            const payload = { ...this.form };
            this.completeCreateChannel(payload);
        },
        handleCancel() {
            this.$emit("cancel");
        },
    },
}
</script>
<style lang="scss" scoped>
#CreateIkasChannel {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 440px;
    margin: 0 auto;
    padding: 32px 16px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .header {
        .ikas-icon {
            width: 96px;
            height: auto;
            margin-bottom: 24px;
            background: #deff37;
            padding: 10px;
            border-radius: 10px;
        }
    }

    .description {
        text-align: center;
        font-size: 14px;
        line-height: 1.6;
        color: #333;
        margin-bottom: 28px;

        .url {
            font-weight: 500;
        }

        .highlight {
            background: #fff3cd;
            padding: 2px 4px;
            border-radius: 3px;
            color: #333;
        }
    }

    .form {
        width: 100%;

        .label {
            display: block;
            margin-bottom: 4px;
            font-size: 13px;
            color: #595959;
        }

        .input {
            width: 100%;
            padding: 10px 12px;
            margin-bottom: 16px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            font-size: 14px;

            &:focus {
                outline: none;
                border-color: #1890ff;
                box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
            }
        }
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        margin-top: 8px;

        .btn {
            min-width: 96px;
            padding: 8px 16px;
            font-size: 14px;
            border-radius: 4px;
            cursor: pointer;
            border: 1px solid #d9d9d9;
            background: #fff;
            color: #333;

            &:hover {
                background: #f5f5f5;
            }
        }

        .cancel {
            margin-right: 12px;
        }

        .primary {
            background: #1890ff;
            border-color: #1890ff;
            color: #fff;

            &:hover {
                background: #40a9ff;
                border-color: #40a9ff;
            }
        }
    }
}
</style>
